<div class="flex flex-col gap-6" *transloco="let t">
  @if (isVideoEnabled()) {
    <div class="flex flex-col gap-2">
      <div class="flex items-start justify-between gap-4">
        <h1 class="font-semibold text-gray-800">{{ t("dsp-creatives.dsp_video") }}</h1>
        <div class="w-fit">
          <app-dsp-rejected-ads-badge [dspAdvertiserId]="dspAdvertiserId()" [strategyId]="strategyId()" />
        </div>
      </div>
      <div class="self-start rounded-lg border px-6 py-3">
        <app-strategy-page-dsp-video />
      </div>
    </div>
  } @else {
    <div class="flex flex-col gap-2">
      <div class="flex items-center justify-between gap-4">
        <h1 class="font-semibold text-gray-800">{{ t("page-title.responsive_ecommerce") }}</h1>
        <div class="w-fit">
          <app-dsp-rejected-ads-badge [dspAdvertiserId]="dspAdvertiserId()" [strategyId]="strategyId()" />
        </div>
      </div>
      <div class="rounded-lg border px-6 py-3">
        <app-dsp-responsive-ecommerce />
      </div>
    </div>
    <div class="flex flex-col gap-2">
      <h1 class="font-semibold text-gray-800">
        {{ t("page-title.display_creatives") }}
        <IBadge class="ml-1" variant="soft" [label]="t('common.beta')"></IBadge>
      </h1>
      <app-dsp-custom-creatives />
    </div>
  }
</div>
